import * as PIXI from 'pixi.js';
import Layers from 'slotworks/graphics/layers/layers';
import particleManager from 'slotworks/graphics/particles/particle-manager';
import Point from 'slotworks/utils/geom/point';

export default function CreateParticle(type: string, name: string, layer: Layers, background: boolean = true) {
    const particleContainer = new PIXI.Container();
    const particle = particleManager.add(type, new Point(0, 0), particleContainer);

    particleContainer.name = "particle-" + type + "_" + name;
    layer.addParticle(particleContainer.name, particle);
    if(background) {
        layer.container.addChildAt(particleContainer, 0);
    } else {
        layer.container.addChild(particleContainer);
    }

    const emitter = particleManager.get(particle);
    emitter.emit = false;
    
    return emitter;
}

export function CreateParticleToContainer(type: string, name: string, particleContainer: PIXI.Container) {    
    const particle = particleManager.add(type, new Point(0, 0), particleContainer);
    particleContainer.name = "particle-" + type + "_" + name;

    const emitter = particleManager.get(particle);
    emitter.emit = false;
    
    return emitter;
}